import EmptyBox from './EmptyBox';

export default EmptyBox;
